<div class="admin-page">
  <div class="table-header">
    <div class="header">
      <h5>
        <fa-icon *ngIf="tableIcon" [icon]="tableIcon"></fa-icon>
        {{ tableTitle }}
      </h5>
      <div class="tab-toggle-wrapper" *ngIf="tabs && tabs.length > 0">
        <div class="tab-toggle-group" role="tablist">
          <button
            type="button"
            class="tab-toggle"
            *ngFor="let tab of tabs"
            (click)="handleTabClick(tab)"
            [class.active]="currentTabId === tab.id"
            role="tab"
          >
            {{ tab.label }}
          </button>
        </div>
      </div>
    </div>
    <div class="toolbar">
      <div class="counter">
        <app-loading
          *ngIf="loading; else showRowCount"
          [size]="'1x'"
        ></app-loading>

        <ng-template #showRowCount>
          {{ rowCount }} {{ "grid.toolbar.items" | translate }}
        </ng-template>
      </div>

      <div class="view-options">
        <div class="actions-dropdown">
          <sui-button
            variant="secondary"
            [leadingIcon]="['fas', 'file-export']"
            [trailingIcon]="['fas', 'caret-down']"
            [expanded]="exportDropdown.isOpen()"
            [suiMenuTrigger]="exportMenu"
            [suiMenuContainer]="dropdownBoundary"
            #exportDropdown="suiMenu"
          >
            {{ "btn.export" | translate }}
          </sui-button>

          <ng-template #exportMenu>
            <sui-menu>
              <!-- Export CSV -->
              <button sui-menu-item (click)="exportGridAsCsv()">
                <fa-icon [icon]="['fas', 'file-csv']"></fa-icon>
                <span>{{ "grid.toolbar.export-csv" | translate }}</span>
              </button>

              <!-- Save -->
              <button
                sui-menu-item
                *ngIf="hasCsvServerSide"
                (click)="exportGridAsCsvServerSide()"
              >
                <fa-icon [icon]="['fas', 'file-csv']"></fa-icon>
                <span>{{
                  "grid.toolbar.export-csv-serverside" | translate
                }}</span>
              </button>
            </sui-menu>
          </ng-template>
        </div>

        <sui-combobox
          class="grid-view-presets"
          [options]="viewPresetOptions"
          placeholder="{{
            'grid.toolbar.placeholder.select-view-preset' | translate
          }}"
          [ngModel]="selectedViewPresetId"
          (ngModelChange)="onViewPresetValueChange($event)"
          [dropdownContainer]="dropdownBoundary"
        ></sui-combobox>

        <div class="actions">
          <!-- Save -->
          <sui-button
            *ngIf="viewSettingsHasChanged"
            variant="primary"
            [leadingIcon]="['fas', 'save']"
            (click)="saveSelectedViewPreset()"
          >
            {{ "btn.save" | translate }}
          </sui-button>

          <div class="actions-dropdown">
            <sui-button
              variant="secondary"
              [leadingIcon]="['fas', 'ellipsis-v']"
              [trailingIcon]="['fas', 'caret-down']"
              [expanded]="presetsDropdown.isOpen()"
              [suiMenuTrigger]="presetsMenu"
              [suiMenuContainer]="dropdownBoundary"
              #presetsDropdown="suiMenu"
            >
              {{ "btn.presets" | translate }}
            </sui-button>

            <ng-template #presetsMenu>
              <sui-menu>
                <!-- Create New -->
                <button sui-menu-item (click)="createViewPresetSettings()">
                  <fa-icon [icon]="['fas', 'plus']"></fa-icon>
                  <span>{{ "btn.create-new" | translate }}</span>
                </button>

                <!-- Save -->
                <button
                  sui-menu-item
                  [disabled]="!viewSettingsHasChanged"
                  (click)="saveSelectedViewPreset()"
                >
                  <fa-icon [icon]="['fas', 'save']"></fa-icon>
                  <span>{{ "btn.save" | translate }}</span>
                </button>

                <!-- Edit -->
                <button
                  sui-menu-item
                  [disabled]="!selectedViewPresetId"
                  (click)="editSelectedViewPreset()"
                >
                  <fa-icon [icon]="['fas', 'edit']"></fa-icon>
                  <span>{{ "btn.edit" | translate }}</span>
                </button>

                <!-- Save As -->
                <button
                  sui-menu-item
                  [disabled]="!selectedViewPresetId"
                  (click)="saveSelectedViewPresetAsNew()"
                >
                  <fa-icon [icon]="['fas', 'copy']"></fa-icon>
                  <span>{{ "btn.save-as" | translate }}</span>
                </button>

                <!-- Delete -->
                <button
                  sui-menu-item
                  [disabled]="!selectedViewPresetId"
                  (click)="deleteSelectedGridSettings()"
                >
                  <fa-icon [icon]="['fas', 'trash']"></fa-icon>
                  <span>{{ "btn.delete" | translate }}</span>
                </button>
              </sui-menu>
            </ng-template>
          </div>
        </div>
      </div>

      <sui-button
        *ngFor="let button of toolbarButtons"
        [variant]="button.variant || 'secondary'"
        [leadingIcon]="button.leadingIcon"
        [disabled]="button.disabled"
        [loading]="button.loading"
        (click)="button.action()"
      >
        {{ button.text }}
      </sui-button>

      <sui-combobox
        *ngIf="dropdownItems.length > 0"
        style="width: 200px"
        [options]="dropdownOptions"
        [placeholder]="dropdownPlaceholder"
        [(ngModel)]="dropdownId"
        [dropdownContainer]="dropdownBoundary"
      ></sui-combobox>
    </div>
  </div>
  <div class="content">
    <!-- Table Section -->
    <div
      class="{{
        'data-table' + (generalGridClassName ? ' ' + generalGridClassName : '')
      }}"
    >
      <ag-grid-angular
        *ngIf="!objectEditorMode; else showObjectEditor"
        style="width: 100%; height: 100%"
        class="ag-theme-sensika"
        [gridOptions]="gridOptions"
        [cellSelection]="true"
        (rowClicked)="onObjectSelected($event)"
        (cellValueChanged)="onCellValueChanged($event)"
        (displayedColumnsChanged)="onDisplayedColumnsChanged()"
        (toolPanelVisibleChanged)="onDisplayedColumnsChanged()"
        [components]="components"
      >
      </ag-grid-angular>
      <ng-template #showObjectEditor>
        <router-outlet></router-outlet>
      </ng-template>
    </div>

    <!-- Details Pane -->
    <div class="details-pane" *ngIf="selectedObject">
      <div class="details-header">
        <div class="title">
          <h4>{{ selectedObject.title }}</h4>
        </div>

        <div class="close">
          <sui-button
            variant="secondary"
            [leadingIcon]="['fas', 'times']"
            [iconOnly]="true"
            ariaLabel="Close"
            (click)="onCloseDetails()"
          ></sui-button>
        </div>
      </div>
      <div class="details-content">
        <!-- Placeholder for child-defined content -->
        <ng-template #dynamicDetailsContainer></ng-template>
      </div>
      <div class="details-toolbar">
        <sui-button variant="secondary" (click)="onCloseDetails()">
          {{ "btn.cancel" | translate }}
        </sui-button>
        <sui-button variant="primary" (click)="onEdit()">
          {{ "btn.save" | translate }}
        </sui-button>
      </div>
    </div>
  </div>
</div>
